var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripthree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "28px",
    viewBox: "0 0 44 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AA10E10F-7B31-4F31-B721-D47F272ADA86") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "amex",
    transform: "translate(4.500000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 35,
    height: 22,
    rx: 1.57142857
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#0071CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0733788,19.5946667 L30.5204778,17.8933333 L28.9078498,19.5946667 L25.7423208,19.5946667 L25.7423208,19.5946667 L18.9334471,19.5946667 L18.9334471,11.6746667 L15.7679181,11.6746667 L19.7098976,2.816 L23.5324232,2.816 L24.9061433,5.86666667 L24.9061433,2.816 L29.6843003,2.816 L30.5204778,5.104 L31.3566553,2.816 L35,2.816 L35,1.46666667 C35,0.645333333 34.3430034,0 33.5068259,0 L1.49317406,0 C0.656996587,0 0,0.645333333 0,1.46666667 L0,20.5333333 C0,21.3546667 0.656996587,22 1.49317406,22 L33.5068259,22 C34.3430034,22 35,21.3546667 35,20.5333333 L35,19.5946667 L32.0733788,19.5946667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.320819, 3.872000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15.1706485 14.784 17.6791809 14.784 14.394198 11.3226667 17.6791809 7.92 15.2303754 7.92 13.1399317 10.1493333 11.109215 7.92 8.60068259 7.92 11.9453925 11.3813333 8.60068259 14.784 11.0494881 14.784 13.1399317 12.5546667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.59897611 13.2 4.59897611 12.144 8.54095563 12.144 8.54095563 10.56 4.59897611 10.56 4.59897611 9.504 8.60068259 9.504 8.60068259 7.92 2.68771331 7.92 2.68771331 14.784 8.60068259 14.784 8.60068259 13.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15.8276451 6.92266667 17.6194539 6.92266667 17.6194539 0 14.7525597 0.0586666667 13.1996587 4.34133333 11.5870307 0.0586666667 8.60068259 0.0586666667 8.60068259 6.92266667 10.5119454 6.92266667 10.5119454 2.112 12.3037543 6.92266667 13.9761092 6.92266667 15.8276451 2.112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55460751,0.0586666667 L3.10580205,0.0586666667 L0,6.92266667 L2.09044369,6.92266667 L2.68771331,5.57333333 L5.91296928,5.57333333 L6.51023891,6.92266667 L8.66040956,6.92266667 L5.55460751,0.0586666667 Z M3.3447099,3.98933333 L4.3003413,1.76 L5.2559727,3.98933333 L3.3447099,3.98933333 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0071CE",
    fillRule: "nonzero",
    points: "33.2679181 15.0186667 35 16.896 35 13.1413333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripthree);
export default __webpack_public_path__ + "static/media/stripthree.60f89fe259f2e6a754270a5860d1f459.svg";
export { ForwardRef as ReactComponent };